// src/composables/usePageTitle.ts
import { watch, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';

export function usePageTitle(initialTitle?: string) {
  const { t, locale } = useI18n();

  // 更新标题的通用方法
  const setTitle = (title?: string) => {
    const finalTitle = title || t('app.title');
    document.title = finalTitle;

    // 兼容SSR和静态HTML的标题元素
    const titleElement =
      document.querySelector('title') ||
      document.getElementById('dynamic-title');
    if (titleElement) {
      titleElement.textContent = finalTitle;
    }
  };
  // 初始化设置
  setTitle(initialTitle);

  // 监听语言变化
  const stopWatcher = watch(locale, () => {
    setTitle();
  });

  // 组件卸载时停止监听
  onBeforeUnmount(() => {
    stopWatcher();
  });

  return { setTitle };
}
